import * as types from '../actiontypes';
import env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';

export function saveInternalUser(engagementId, data) {
	const url = env.getBaseURL(serviceURL, engagementId) + 'InternalUsers';

	return {
		type: types.POST_INTERNAL_USER,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data
			}
		},
		resolve: true
	};
}

export function patchDeactivateInternalUsers(engagementId, data) {
	const url = env.getBaseURL(serviceURL, engagementId) + 'InternalUsers';
	return {
		type: types.PATCH_DEACTIVATE_USERS_LIST,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: data
			}
		},
		userIds: data.map((u) => u.path)
	};
}

export function getInternalUsers(engagementId, userStatuses, gui, pageSize, page, resource) {
	let url = env.getBaseURL(serviceURL, engagementId) + 'InternalUsers?';

	let allUserStatus = '';

	if (userStatuses) {
		userStatuses.forEach((userStatus) => {
			allUserStatus =
				allUserStatus === '' ? allUserStatus + 'UserStatus=' + userStatus : allUserStatus + '&UserStatus=' + userStatus;
		});

		url = url + allUserStatus;
	}

	if (gui) {
		url = url + '&gui=' + gui;
	}

	url = url + `&pageSize=${pageSize}&currentPage=${page}&page=${page}`;

	return {
		type: types.GET_INTERNAL_USERS,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource}
			}
		}
	};
}
